import { createReducer, on } from "@ngrx/store";
import {
  EditAdministratorState,
  initialEditAdministratorState,
} from "./edit-administrator.state";
import {
  ClearEditAdministratorState,
  UpdateAdmin,
  UpdateAdminError,
  UpdateAdminSuccess,
  GetAdmin,
  GetAdminError,
  GetAdminSuccess,
} from "./edit-administrator.actions";

export const EditAdministratorReducers = createReducer(
  initialEditAdministratorState,
  on(GetAdmin, (state): EditAdministratorState => {
    return {
      ...state,
      loading: true,
      admin: null,
      update: false,
      emailList: [],
    };
  }),
  on(GetAdminSuccess, (state, action): EditAdministratorState => {
    return {
      ...state,
      loading: false,
      admin: action.userProfile,
      update: false,
      emailList: action.emailList,
    };
  }),
  on(GetAdminError, (state, action): EditAdministratorState => {
    return {
      ...state,
      loading: false,
      error: action.error,
      update: false,
    };
  }),
  on(UpdateAdmin, (state): EditAdministratorState => {
    return {
      ...state,
      loading: true,
      admin: null,
      update: false,
    };
  }),
  on(UpdateAdminSuccess, (state, action): EditAdministratorState => {
    return {
      ...state,
      loading: false,
      update: true,
    };
  }),
  on(UpdateAdminError, (state, action): EditAdministratorState => {
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  }),
  on(ClearEditAdministratorState, (state): EditAdministratorState => {
    return {
      ...state,
      loading: false,
      admin: null,
      error: null,
    };
  })
);
